import React, { useEffect, useState } from 'react'
import Datepicker from "react-tailwindcss-datepicker";
import { get } from '../util/request';
import { useSelector } from 'react-redux';
import { format } from 'date-fns';

const ListAbsen = (props) => {
    const [state, setState] = useState({
        attendanceList: '',
        startDate: format(new Date(), "yyyy-MM-dd"),
        dateForm: {
            startDate: '',
            endDate: '',
        },
        loading: true
    })

    const jwtToken = useSelector(state => state.auth.generateToken)
    const user = useSelector(state => state.auth.user)
    useEffect(() => {
        console.log(user.employee_fullname)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    useEffect(() => {
        let isMounted = true
        if (isMounted) {

            getAttendanceList()
        }
        return () => isMounted === false
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [state.dateForm])

    const getAttendanceList = () => {
        get(
            `public/api/v1/member/attendance/list?company_id=${user.company_id}&date=${state.startDate}`,
            {
                headers: {
                    Authorization: `Bearer ${jwtToken}`,
                    'Content-Type': 'application/json'
                },
            },
            success => {
                setState(prevState => {
                    return {
                        ...prevState,
                        // tasksList: success.data.Data,
                        attendanceList: success.data.Data,
                        loading: false
                    }
                })
            },
            error => {
                setState(prevState => {
                    return {
                        ...prevState,
                        loading: false
                    }
                })
                console.log('error request', error)
            }
        )
    }

    const handleValueChange = (newValue) => {
        setState({
            ...state,
            dateForm: newValue
        });
    }
    return (
        state.loading ? '' :
            <div className='relative w-full h-screen grid-cols-1 sm:grid-cols-2 bg-primary'>
                <div className='w-full h-20 bg-primary'>
                    <div className='flex items-center h-full gap-4 px-4'>
                        <a href={process.env.PUBLIC_URL + "/home"}>
                            <img alt='logo_home' src={process.env.PUBLIC_URL + "/assets/img/arrow-left.svg"} className='justify-start w-10 py-1' />
                        </a>
                        <div className='w-full h-full py-4'>
                            <div className='relative sm:col-span-2'>
                                <input
                                    type="text"
                                    placeholder="Mencari Nama/ID"
                                    name="password"
                                    id="password"
                                    autoComplete="password"
                                    className="w-full px-4 py-2 text-base border border-gray-300 rounded-lg outline-none bg-real-white focus:ring-blue-500 focus:border-blue-500 focus:ring-1"
                                />
                                <button
                                    className="absolute right-0 flex items-center px-4 text-gray-600 bottom-3"
                                // onClick={togglePasswordVisibility}
                                >
                                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" className="w-5 h-5">
                                        <path stroke-linecap="round" stroke-linejoin="round" d="m21 21-5.197-5.197m0 0A7.5 7.5 0 1 0 5.196 5.196a7.5 7.5 0 0 0 10.607 10.607Z" />
                                    </svg>

                                    {/* <svg
                                xmlns="http://www.w3.org/2000/svg"
                                fill="none"
                                viewBox="0 0 24 24"
                                strokeWidth={1.5}
                                stroke="currentColor"
                                className="w-5 h-5"
                            >
                                <path
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    d="M3.98 8.223A10.477 10.477 0 001.934 12C3.226 16.338 7.244 19.5 12 19.5c.993 0 1.953-.138 2.863-.395M6.228 6.228A10.45 10.45 0 0112 4.5c4.756 0 8.773 3.162 10.065 7.498a10.523 10.523 0 01-4.293 5.774M6.228 6.228L3 3m3.228 3.228l3.65 3.65m7.894 7.894L21 21m-3.228-3.228l-3.65-3.65m0 0a3 3 0 10-4.243-4.243m4.242 4.242L9.88 9.88"
                                />
                            </svg> */}

                                </button>

                            </div>

                        </div>
                    </div>
                </div>
                <div className='w-full px-4 bg-primary'>
                    <div className='flex w-full h-full gap-2 py-4'>
                        <div className='w-1/2'>
                            <Datepicker
                                asSingle={true}
                                useRange={false}
                                placeholder={"Tanggal Izin"}
                                primaryColor={"blue"}
                                value={state.dateForm}
                                onChange={handleValueChange}
                            />
                        </div>

                        <div className='w-1/2 text-right'>
                            <p className='text-sm font-semibold text-gray-600'>Total Karyawan</p>
                            <p className='text-lg font-bold text-red-600'>{state.attendanceList.total_employee}</p>
                        </div>

                    </div>
                    <div className='flex justify-center w-full h-full gap-2 py-4 text-center'>
                        <div>
                            <img alt='logo_home' src={process.env.PUBLIC_URL + "/assets/img/checklist.svg"} className='mx-auto' />
                            <p className='text-xs'>Karyawan Hadir</p>
                            <p className='font-bold'>{state.attendanceList.total_attendance_success}</p>
                        </div>
                        <div>
                            <img alt='logo_home' src={process.env.PUBLIC_URL + "/assets/img/cross.svg"} className='mx-auto' />
                            <p className='text-xs'>Karyawan Absen</p>
                            <p className='font-bold'>{state.attendanceList.total_attendance_absence}</p>
                        </div>
                        <div>
                            <img alt='logo_home' src={process.env.PUBLIC_URL + "/assets/img/list.svg"} className='mx-auto' />
                            <p className='text-xs'>Karyawan Izin</p>
                            <p className='font-bold'>{state.attendanceList.total_attendance_permit}</p>
                        </div>
                        <div>
                            <img alt='logo_home' src={process.env.PUBLIC_URL + "/assets/img/add.svg"} className='mx-auto' />
                            <p className='text-xs'>Karyawan Sakit</p>
                            <p className='font-bold'>{state.attendanceList.total_attendance_sick}</p>
                        </div>

                    </div>


                </div>
                <div className='absolute bottom-0 w-full p-4 h-2/3 bg-real-white rounded-3xl'>
                    <div>
                        <p className='text-lg font-bold'>Absensi Harian</p>
                    </div>
                    {state.attendanceList.detail.map((item, index) => (
                        <div className='flex justify-between py-4 border-b-2 border-gray-200'>
                            <p className='font-bold'>{index + 1}</p>
                            <p className='w-3/4 font-bold'>{item.employee?.employee_fullname}</p>
                            <img alt='logo_home'
                                src={item.attendance_absence_type === 1 ? process.env.PUBLIC_URL + "/assets/img/checklist.svg" :
                                    item.attendance_absence_type === 2 ? process.env.PUBLIC_URL + "/assets/img/cross.svg" :
                                        item.attendance_absence_type === 3 ? process.env.PUBLIC_URL + "/assets/img/add.svg" :
                                        process.env.PUBLIC_URL + "/assets/img/list.svg"} />
                        </div>
                    ))}
                   
                </div>




            </div >

    )
}

export default ListAbsen